<template>
  <div class="notification notification--success">
    <div class="notification__icon">
      <icon fill="#6a9432" type="check" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'af-success-notification',

  components: {
    'icon': Icon
  }
}
</script>

<style lang="postcss" scoped>
.notification {
  align-items: center;
  background-color: var(--color-kidnapper);
  border: 1px solid #d0ddbe;
  border-radius: 4px;
  display: flex;
  padding: 15px;
  position: relative;

  &:not(:last-child) {
    margin-bottom: var(--spacing-third);
  }

  & p {
    margin: 0;
  }
}

.notification__icon {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AfSuccessNotification.vue